import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HackyService {

  constructor() {}

  @Output() ispiratiChange = new EventEmitter<any>();
  @Output() hideNewsletter = new EventEmitter<boolean>();
  @Output() openbannerCookies = new EventEmitter<boolean>();

  @Output() showDettaglioMobileSticky = new EventEmitter<boolean>();
  @Output() showConfiguraDettaglioMobileSticky = new EventEmitter<boolean>();
  @Output() aggiungCarrelloDisabledDettaglioMobileSticky = new EventEmitter<boolean>();
  @Output() aggiungiCarrelloDettaglioMobileSticky = new EventEmitter<void>();
}
